import { useMemo } from 'react'
import { trpc, type RouterOutputs } from '@klear/ui/lib/trpc'
import { useMutationWithToast } from '@klear/ui/hooks/use-mutations-with-toast'

const DISBURSEMENTS_POLL_INTERVAL_MS = 8000

export type DisbursementRow = RouterOutputs['disbursement']['listDisbursementPayments'][number]
export type DisbursableAdvanceRow = RouterOutputs['disbursement']['listDisbursableAdvances'][number]

export function useListDisbursementPayments(enabled = true) {
  const { data, isLoading } = trpc.disbursement.listDisbursementPayments.useQuery(
    {},
    {
      enabled,
      refetchInterval: DISBURSEMENTS_POLL_INTERVAL_MS
    }
  )
  return { disbursements: data ?? [], isLoading }
}

export function useDisbursableAdvances(traderId: number | null, enabled = true) {
  const { data, isLoading } = trpc.disbursement.listDisbursableAdvances.useQuery(
    { filters: { traderId: traderId ?? undefined } },
    {
      enabled: enabled && traderId != null
    }
  )
  const disbursableAdvances = useMemo(
    () => (data ?? []).filter((advance) => advance.fundBlocker == null).map((advance) => advance.offer),
    [data]
  )
  return { disbursableAdvances, isLoading }
}

export function useAllDisbursableAdvances(enabled = true) {
  const { data, isLoading } = trpc.disbursement.listDisbursableAdvances.useQuery(
    {},
    {
      enabled,
      refetchInterval: DISBURSEMENTS_POLL_INTERVAL_MS
    }
  )
  return { disbursableAdvances: data ?? [], isLoading }
}

export function useDisbursementMutations() {
  const disburseAdvancesMutation = useMutationWithToast(trpc.disbursement.disburseAdvances.useMutation, {
    successTitle: null,
    errorTitle: 'Disbursement failed'
  })

  return {
    disburseAdvances: disburseAdvancesMutation.mutateAsync,
    isDisbursing: disburseAdvancesMutation.isPending
  }
}
